import { Typography } from '@equinor/eds-core-react'
import { info_circle } from '@equinor/eds-icons'
import { ReactElement, ReactNode } from 'react'
import { InfoBanner } from './InfoBanner'

interface EmptyStateBannerProps {
    title: string
    message: ReactNode
}

export function EmptyStateBanner({ title, message }: EmptyStateBannerProps): ReactElement {
    return (
        <InfoBanner icon={info_circle}>
            <Typography as="div" variant="h6" group="heading" color="inherit">
                <strong>{title}</strong>
                <br />
                {message}
            </Typography>
        </InfoBanner>
    )
}
